// extracted by mini-css-extract-plugin
module.exports = {"root":"VideoCarousel_root__zdQm2","btn":"VideoCarousel_btn__4TudI","title":"VideoCarousel_title__7unfO"};